import React from 'react';
import { Input } from '@repo/ui/components/Input';
import { cn } from '@repo/ui/utils';
import { FormField } from './FormField';

interface FormInputFieldProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  id: string;
  error?: string | null;
  fieldClassName?: string;
  labelClassName?: string;
}

export const FormInputField = React.forwardRef<
  HTMLInputElement,
  FormInputFieldProps
>(({ label, id, error, fieldClassName, labelClassName, required, className, ...inputProps }, ref) => {
  const errorId = `${id}-error`;
  return (
    <FormField
      label={label}
      htmlFor={id}
      error={error}
      errorId={errorId}
      className={fieldClassName}
      labelClassName={labelClassName}
      required={required}
    >
      <Input
        ref={ref}
        id={id}
        required={required}
        aria-describedby={error ? errorId : undefined}
        aria-invalid={error ? true : undefined}
        className={cn(error && 'border-destructive-ghost-foreground', className)}
        {...inputProps}
      />
    </FormField>
  );
});
FormInputField.displayName = 'FormInputField';
